<template>
  <b-nav-item-dropdown
    v-if="organizations.length > 1"
    right
    toggle-class="d-flex align-items-center"
    class="dropdown-organization mr-1"
  >
    <template #button-content>
      <feather-icon size="16" icon="GridIcon" class="mr-50" />
      <span class="d-none d-sm-inline font-weight-bolder">{{ currentOrgName }}</span>
      <feather-icon size="14" icon="ChevronDownIcon" class="ml-50" />
    </template>

    <b-dropdown-header>Switch Organization</b-dropdown-header>

    <b-dropdown-item
      v-for="org in organizations"
      :key="org._id"
      link-class="d-flex align-items-center"
      :active="org._id === currentOrgId"
      @click="switchOrganization(org)"
    >
      <feather-icon
        size="16"
        :icon="org._id === currentOrgId ? 'CheckCircleIcon' : 'CircleIcon'"
        class="mr-50"
      />
      <span>{{ org.organization_name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownHeader,
} from 'bootstrap-vue'
import { POST_API } from '../../../../../store/actions.type'
import { UPDATE_USER_INFO } from '../../../../../store/mutations.type'
import JwtService from '../../../../../common/jwt.service'
import Swal from 'sweetalert2'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownHeader,
  },
  data() {
    return {
      currentOrgId: null,
      currentOrgName: '',
      organizations: [],
    }
  },
  methods: {
    loadOrganizations() {
      this.$store.dispatch(POST_API, {
        data: {},
        api: '/api/my-organizations',
      })
        .then(data => {
          if (data && data.success) {
            this.organizations = data.organizations || []
            this.currentOrgId = data.current_organization ? String(data.current_organization) : null

            var current = this.organizations.find(o => String(o._id) === this.currentOrgId)
            this.currentOrgName = current ? current.organization_name : (this.organizations[0] ? this.organizations[0].organization_name : '')
          }
        })
        .catch(() => {})
    },

    switchOrganization(org) {
      if (!org || String(org._id) === this.currentOrgId) {
        return
      }

      this.$store.dispatch(POST_API, {
        data: { organization_id: org._id },
        api: '/api/switch-organization',
      })
        .then(data => {
          if (data && data.success) {
            // Silent token swap — no credentials re-entered.
            JwtService.setToken(data.token)

            // Keep persisted Vuex user state in sync with the newly active org —
            // report/export links across the app read currentUser.organization directly.
            this.$store.commit(UPDATE_USER_INFO, {
              userId: Object.assign({}, this.$store.getters.currentUser, { organization: org._id }),
            })

            // Keep the stored user's active org in sync for local display.
            try {
              var userData = JSON.parse(localStorage.getItem('userData'))
              if (userData) {
                userData.organization = org._id
                localStorage.setItem('userData', JSON.stringify(userData))
              }
            } catch (e) { /* ignore */ }

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Switched to ' + org.organization_name,
              showConfirmButton: false,
              timer: 1200,
            }).then(() => {
              // Reload so every screen refetches data scoped to the new organization.
              window.location.reload(true)
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Unable to switch',
              text: (data && data.message) ? data.message : 'You do not have access to this organization',
            })
          }
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Unable to switch',
            text: (err && err.message) ? err.message : 'Something went wrong.',
          })
        })
    },
  },
  mounted() {
    this.loadOrganizations()
  },
}
</script>
